import axiosInstance from "./axiosInstance";

const notesService = {
    create: async (payload) => {
        try {
            const response = await axiosInstance.post('/notes/create', payload);
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchAll: async () => {
        try {
            const response = await axiosInstance.get('/notes/all');
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    fetchTotal: async () => {
        try {
            const response = await axiosInstance.get('/notes/total');
            return response.data
        } catch (error) {
            throw error.response.data
        }
    },
    delete: async (id) => {
            try {
                const response = await axiosInstance.delete(`/notes/delete/${id}`)
                return response.data;
            } catch (error) {
                throw error.response.data;
            }
    },

    udpate: async (id, data) => {
            try {
                const response = await axiosInstance.put(`/notes/update/${id}`, data)
                return response.data;
            } catch (error) {
                throw error.response.data;
            }
    },
}

export default notesService